<template>
  <v-container fluid style="height: 100%">
    <v-container
      fluid
      v-if="!hasError && isAdmin()"
      class="py-5 px-5 py-sm-15 px-sm-10 fill-height align-start"
    >
      <v-row>
        <v-col>
          <!--heading-->
          <v-row>
            <v-col class="text-start">
              <span class="textLight--text font-weight-medium text-h5">
                {{ $t("user.profile.companyProfile.companyProfile") }}
              </span>
            </v-col>
          </v-row>

          <!--content-->
          <v-row>
            <!--left section-->
            <v-col cols="12" md="6">
              <!--logo-->
              <v-row>
                <v-col cols="12" sm="5" md="7" lg="5" xl="3">
                  <CompanyProfileCard
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                    :imgHeight="'125'"
                    :imgWidth="'145'"
                  />
                </v-col>
              </v-row>

              <!--basic info-->
              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("user.basicInfo") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <CompanyBasicInfo
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("introVideo") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <IntroVideo
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>

              <!--invoice priority-->
              <!--              <v-row>
                <v-col class="text-start">
                  <span class="textLight&#45;&#45;text font-weight-medium text-h5">
                    {{ $t("user.profile.companyProfile.invoicePriority") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card flat class="px-4 py-3" height="100%">
                    <v-row align="center">
                      <v-col cols="4">
                        <span class="textLight&#45;&#45;text">
                          {{ $t("user.profile.companyProfile.unitPrice") }}
                        </span></v-col
                      >
                      
                      <v-col cols="2">
                        <v-switch
                          flat
                          dense
                          hide-details
                          inset
                          color="primary"
                          class="ma-0"
                          v-model="invoicePrioritySwitch"
                          :loading="priorityUpdateLoading"
                          @change="
                            value =>
                              updateInvoicePriority(
                                value ? 'enable' : 'disable'
                              )
                          "
                        >
                        </v-switch
                      ></v-col>
                      
                      <v-col cols="auto" class="text-start">
                        <span class="textLight&#45;&#45;text">
                          {{
                            $t("user.profile.companyProfile.individualPrice")
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>-->

              <!--bank details-->
              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("user.profile.companyProfile.bankDetails") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <CompanyBankDetails
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>

              <!--VAT details-->

              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("user.profile.companyProfile.vatDetails") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <CompanyVatDetails
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>

              <!--otherSettings-->

              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("user.profile.companyProfile.otherSettings") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <CompanyProfileOtherSettings
                    @onError="snackbar = true"
                    :companyData="companyProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-col>

            <!--right section-->
            <v-col cols="12" md="6">
              <!--terms-->
              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("termsAndConditions") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-card
                    flat
                    class="px-4 py-3 text-start"
                    height="100%"
                    min-height="50"
                  >
                    <LocalisedContentEditable
                      :values="termsAndConditions"
                      @update:values="values => (termsAndConditions = values)"
                      :text-area-outlined="false"
                      :editable="isEditCard1"
                      css-class="text-subtitle-1 font-weight-regular textLight--text"
                      :showLanguageTabs="false"
                    />

                    <float-btn
                      v-if="!loading"
                      :isEdit="isEditCard1"
                      @save="saveTermsAndConditions"
                      @edit="isEditCard1 = true"
                      :bottom="true"
                      :align="'right'"
                      :loading="savingData1"
                    />
                  </v-card>
                </v-col>
              </v-row>

              <!--privacy-->
              <v-row>
                <v-col class="text-start">
                  <span class="textLight--text font-weight-medium text-h5">
                    {{ $t("privacyPolicy") }}
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-card
                    flat
                    class="px-4 py-3 text-start"
                    height="100%"
                    min-height="50"
                  >
                    <LocalisedContentEditable
                      :values="privacyPolicy"
                      @update:values="values => (privacyPolicy = values)"
                      :text-area-outlined="false"
                      :editable="isEditCard2"
                      css-class="text-subtitle-1 font-weight-regular textLight--text"
                      :showLanguageTabs="false"
                    />

                    <float-btn
                      v-if="!loading"
                      :isEdit="isEditCard2"
                      @save="savePrivacyPolicy"
                      @edit="isEditCard2 = true"
                      :bottom="true"
                      :align="'right'"
                      :loading="savingData2"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="hasError" fluid class="fill-height">
      <Error />
    </v-container>
    <v-snackbar v-model="snackbar" timeout="3000">
      {{ $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Error from "../../core-module/components/Error.vue";
import IntroVideo from "../components/company-profile/CompanyProfileIntoVideo.vue";
import CompanyProfileCard from "../components/company-profile/CompanyProfileCard.vue";
import CompanyBasicInfo from "../components/company-profile/CompanyProfileBasicInfo.vue";
import CompanyBankDetails from "../components/company-profile/CompanyProfileBankInfo.vue";
import CompanyVatDetails from "../components/company-profile/CompanyProfileVatInfo.vue";
import LocalisedContentEditable from "../../core-module/components/LocalisedContentEditable.vue";
import FloatBtn from "../components/employee-profile/FloatBtn.vue";
import CompanyProfileOtherSettings from "@/app/user-module/components/company-profile/CompanyProfileOtherSettings";

import { createOrUpdateSubscriberProfile } from "../methods/createOrUpdateSubscriberProfile";
import { hasPermission, isAdmin } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    CompanyProfileOtherSettings,
    Error,
    IntroVideo,
    CompanyProfileCard,
    CompanyBasicInfo,
    CompanyBankDetails,
    CompanyVatDetails,
    LocalisedContentEditable,
    FloatBtn,
  },
  data() {
    return {
      snackbar: false,
      hasError: false,
      companyProfile: {},
      loading: true,
      invoicePrioritySwitch: false,
      priorityUpdateLoading: false,
      termsAndConditions: null,
      isEditCard1: false,
      savingData1: false,
      privacyPolicy: null,
      isEditCard2: false,
      savingData2: false,
    };
  },
  apollo: {
    getSubscriberProfile() {
      return {
        query: require("../api/query/getSubscriberProfile.gql"),
        result({ data, loading, error }) {
          if (data && data.getSubscriberProfile) {
            this.companyProfile = data.getSubscriberProfile;
            if (this.companyProfile?.invoicePriority === "UNIT_PRICE")
              this.invoicePrioritySwitch = false;
            if (this.companyProfile?.invoicePriority === "INDIVIDUAL_PRICE")
              this.invoicePrioritySwitch = true;
            this.termsAndConditions = this.companyProfile?.termsAndConditions;
            this.privacyPolicy = this.companyProfile?.privacyPolicy;
          } else if (error) {
            error.graphQLErrors.map(({ type }, i) => {
              if (type === "FORBIDDEN") this.hasError = true;
              else this.hasError = false;
            });
          }

          this.loading = loading;
        },
      };
    },
  },

  methods: {
    isAdmin,
    async updateInvoicePriority() {
      let updateValue = null;
      if (this.invoicePrioritySwitch) updateValue = "INDIVIDUAL_PRICE";
      else updateValue = "UNIT_PRICE";
      await createOrUpdateSubscriberProfile({
        invoicePriority: updateValue,
      });
    },
    async saveTermsAndConditions() {
      this.savingData1 = true;
      this.isEditCard1 = false;
      await this.update({
        termsAndConditions: this.filterEmptyLocalisedValues(
          this.termsAndConditions
        ),
      }).then(response => {
        this.savingData1 = false;
      });
    },
    async savePrivacyPolicy() {
      this.savingData2 = true;
      this.isEditCard2 = false;

      await this.update({
        privacyPolicy: this.filterEmptyLocalisedValues(this.privacyPolicy),
      }).then(response => {
        this.savingData2 = false;
      });
    },
    update(data) {
      return createOrUpdateSubscriberProfile(data);
    },
  },
};
</script>
